import React, {useState} from 'react';
import {Button, Chip, Divider, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {TableFilter} from '@store/common/tableFilter.model';

import {Cross} from '@icons/index';
import TableReportFiltersDrawer from '@screens/admin/reports/table/filters/TableReportFilters.drawer';

interface TableReportFiltersComponentProps {
  filters: TableFilter[];
  handleReset: () => void;
  handleSave: (tableFilters: TableFilter[]) => void;
}

const TableReportFiltersComponent = (props: TableReportFiltersComponentProps) => {
  const {filters, handleReset, handleSave} = props;

  const {t} = useTranslation();

  const [openFilters, setOpenFilters] = useState(false);

  const filteredFilters = filters.filter((f) => !f.hide && !!f.values.length);

  return (
    <>
      <Stack alignItems="flex-end" spacing={1}>
        <Stack direction="row" spacing={1.5} height="40px" alignItems="center">
          <Button onClick={handleReset} variant="contained" color="primary" startIcon={<Cross/>} size="small">
            {t('global.resetFilters')}
          </Button>
          <Divider variant="fullWidth" orientation="vertical" sx={{height: '30px'}}/>
          <Button onClick={() => setOpenFilters(true)} variant="outlined" color="primary" size="small">
            {t('global.filters')}
          </Button>
        </Stack>
        {!!filteredFilters.length && (
          <Stack direction="row-reverse" alignItems="center" spacing={1}>
            {filteredFilters.map((f, index) => (
              <Chip
                key={`Active filter ${f.type} ${index}`}
                color="primary"
                disabled={f.disabled}
                onDelete={!f.disabled
                  ? () => handleSave(filters.map((of) => of.type === f.type ? ({...of, values: []}) : of))
                  : undefined
                }
                label={`${t(`global.filterFieldType.${f.type}`)} (${f.values.length})`}
                size="small"/>
            ))}
          </Stack>
        )}
      </Stack>
      {openFilters && (
        <TableReportFiltersDrawer
          filters={filters}
          handleSave={(newFilters) => {
            handleSave(newFilters);
            setOpenFilters(false);
          }}
          handleClose={() => setOpenFilters(false)}/>
      )}
    </>
  );
};

export default TableReportFiltersComponent;
